module.exports = __webpack_public_path__ + "media/images/flags/EG-641e1fdbb2ba3c340ff880d79b9afa9b.svg";